import { RenovationInputs, CalculationResult, CostBreakdown } from '../types/renovation';
import { RENOVATION_RATES, getServiceLabel } from './calculationRates';

export function calculateRenovationCosts(inputs: RenovationInputs): CalculationResult {
  const breakdown: CostBreakdown[] = [];
  
  Object.entries(inputs.services).forEach(([serviceId, service]) => {
    if (service.enabled && service.area > 0) {
      const rate = RENOVATION_RATES[serviceId as keyof typeof RENOVATION_RATES];
      breakdown.push({
        category: getServiceLabel(serviceId as keyof typeof RENOVATION_RATES, 'en'),
        categoryFr: getServiceLabel(serviceId as keyof typeof RENOVATION_RATES, 'fr'),
        cost: service.area * rate.rate,
        details: {
          areaType: 'Custom',
          area: service.area,
          ratePerSqm: rate.rate,
          enabled: service.enabled
        }
      });
    }
  });

  const totalCost = breakdown.reduce((sum, item) => sum + item.cost, 0);

  return {
    totalCost,
    breakdown
  };
}